export default __webpack_public_path__ + "static/media/pazdziernik.423168fd.mp3";